// extracted by mini-css-extract-plugin
export var container = "VideoModule-module--container--e2bf3";
export var iframe = "VideoModule-module--iframe--addee";
export var playIcon = "VideoModule-module--playIcon--b010d";
export var thumbnailButton = "VideoModule-module--thumbnailButton--c7c84";
export var videoWrapper = "VideoModule-module--videoWrapper--76539";